export function setColor(){
  if(document.cookie.indexOf("PageColor=")===-1){
    GreenTheme(false);
  }else{
    if(readCookie("PageColor")==="Green"){
      GreenTheme(true);
    }
    if(readCookie("PageColor")==="Yellow"){
      YellowTheme(true);
    }
    if(readCookie("PageColor")==="Orange"){
      OrangeTheme(true);
    }
    if(readCookie("PageColor")==="Purple"){
      PurpleTheme(true);
    }
    if(readCookie("PageColor")==="Blue"){
      BlueTheme(true);
    }
  }
}

//Search Cookie Value
function readCookie(name){
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)===' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ)===0) {
      return decodeURIComponent( c.substring(nameEQ.length,c.length) );
    }
  }
  return null;
}

//Set new time
function NewDate(){
  var CookieDate=new Date();
  CookieDate.setFullYear(CookieDate.getFullYear() +10);
  return CookieDate.toUTCString();
}

//-- Change Color Functions
function GreenTheme(exist){
  if(!exist){
    document.cookie="PageColor=Green; expires="+ NewDate() +"; path=/";
  }
  document.documentElement.style.setProperty("--default-color", "#00be6b");
  document.documentElement.style.setProperty("--default-color-hover", "#019a57");
  document.documentElement.style.setProperty("--default-color-light", "#80d493");
}
function YellowTheme(exist){
  if(!exist){
    document.cookie="PageColor=Yellow; expires="+ NewDate() +"; path=/";
  }
  document.documentElement.style.setProperty("--default-color", "#dcc03e");
  document.documentElement.style.setProperty("--default-color-hover", "#c9ad2a");
  document.documentElement.style.setProperty("--default-color-light", "#ead36b");
}
function OrangeTheme(exist){
  if(!exist){
    document.cookie="PageColor=Orange; expires="+ NewDate() +"; path=/";
  }
  document.documentElement.style.setProperty("--default-color", "#f0932b");
  document.documentElement.style.setProperty("--default-color-hover", "#cc7a20");
  document.documentElement.style.setProperty("--default-color-light", "#f1a34b");
}
function PurpleTheme(exist){
  if(!exist){
    document.cookie="PageColor=Purple; expires="+ NewDate() +"; path=/";
  }
  document.documentElement.style.setProperty("--default-color", "#936baf");
  document.documentElement.style.setProperty("--default-color-hover", "#76598d");
  document.documentElement.style.setProperty("--default-color-light", "#b585d6");
}
function BlueTheme(exist){
  if(!exist){
    document.cookie="PageColor=Blue; expires="+ NewDate() +"; path=/";
  }
  document.documentElement.style.setProperty("--default-color", "#2980b9");
  document.documentElement.style.setProperty("--default-color-hover", "#1f628f");
  document.documentElement.style.setProperty("--default-color-light", "#48a3de");
}
